import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export default class Panel extends Component {
  static propTypes = {
    title: PropTypes.string
  };

  render() {
    return (
      <Wrapper clasName={this.props.className}>
        <Title>{this.props.title}</Title>
        {this.props.children}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
`;
const Title = styled.div`
  font-size: 1.1rem;
  color: #087cbc;
  padding: 11px 11px 11px 20px;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`;



// WEBPACK FOOTER //
// ./src/module-schedule/Panel.js